import {FeaturesEnum} from 'presentation/constants';
import {useFeatureFlagsQuery} from 'presentation/queries/useFeatureFlagsQuery';

import {FeatureFlagsResult} from './types';

export function useMultipleFeatureFlags<T extends Record<string, FeaturesEnum>>(
	flags: T,
): FeatureFlagsResult<T> {
	const {data: featureFlags} = useFeatureFlagsQuery();

	const featureFlagsMap = Object.fromEntries(
		(featureFlags ?? []).map(feature => [feature.flag, feature.enabled]),
	);

	return Object.entries(flags).reduce((acc, [key, flagName]) => {
		acc[key as keyof T] = featureFlagsMap[flagName] ?? false;
		return acc;
	}, {} as FeatureFlagsResult<T>);
}
